import moment from "moment";

const initialState = {
  // start_date: moment().format("YYYY-MM-DD"),
  // end_date: moment().format("YYYY-MM-DD"),
  // group_ids: ['All'],
  // group_categories: ['All'],
  // resident_statuses: ['All'],
};

export function searchReducer(state = initialState, { type, payload }) {
  switch (type) {
    case "UPDATE_FILTERS":
      return { ...state, ...payload };
    case "UPDATE_DATES_FILTERS":
      return { ...state, ...payload };
    default:
      return state;
  }
}
